import styled from 'styled-components'
import { Button } from '@raysync/common/components'
import { Media, NewMedia } from '@raysync/common/theme'

export const Container = styled.div`
  width: 100%;
  position: relative;
  height: 800px;
  overflow: hidden;
  z-index: 0;
  flex-wrap: wrap;
  ${Media.phone`
    height: 14.1rem;
  `}
`

export const BannerButton = styled(Button)`
  width: 180px;
  height: 50px;
  box-shadow: 0px 10px 20px 0px rgba(253, 92, 31, 0.3);
  border-radius: 25px;
  margin: 0 auto;
  display: block;
  ${Media.phone`
    height: .8rem;
    line-height: .8rem;
    width: 3rem;
  `}
`

export const BannerWrap = styled.div`
  position: relative;
  height: ${p => (p.isSmb ? '580px' : '680px')};
  overflow: hidden;
  padding-top: 60px;
  ${Media.phone`
    height: ${p => (p.isSmb ? '12rem' : '10.2rem')};
    padding-top: 0;
  `}
  .smb-bg {
    height: 680px;
  }
`

export const BannerContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  height: 100%;
  ${NewMedia.phone`
    padding: 0 .3rem;
    flex-direction: column;
    justify-content: flex-start;
  `}
`

export const BannerLeftBox = styled.div`
  width: 640px;
  display: flex;
  align-items: center;

  > p {
    font-size: 16px;
    margin-bottom: 28px;
    color: ${p => p.theme.color.textDarkPlus};
    line-height: 24px;
  }

  .left-box-wrapper {
    width: 100%;
    margin-top: ${p => (p.isSmb ? '0' : '-60px')};
    .banner-2-title {
      font-size: 48px;
      line-height: 0.8;
      font-weight: bold;
    }
    .banner-2-sub-title {
      margin-top: 28px;
      margin-bottom: 30px;
      p {
        font-size: 20px;
        color: #252a3a;
        line-height: 1.2;
      }
    }
  }
  ${Media.phone`
    width: 100%;
    .left-box-wrapper {
      padding-top: 1.83rem;
      margin-top: 0;
      .banner-2-title {
        font-size: .6rem;
        text-align: left;
        line-height: 1;
      }
      .banner-2-sub-title {
        margin-bottom: .4rem;
        p {
          font-size: .36rem;
          text-align: left;
          line-height: 1.4;
        }
      }
    }
    > p {
      font-size: .2rem;
      margin-bottom: .3rem;
      line-height: .3rem;
    }
  `}
  ${p => p.theme.Hack.ja`
    .left-box-wrapper {
      .banner-2-sub-title {
        p {
          font-size: 24px;
        }
      }
    }
  `}
`

export const OffBox = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  justify-content: space-between;
  width: 560px;
  svg {
    width: 64px;
    height: 64px;
    margin-right: 20px;
    margin-left: 16px;
  }
  .banner-desc {
    font-size: 24px;
    line-height: 1;
    color: ${p => p.theme.color.secondary};
    b {
      font-size: 48px;
    }
  }
  p {
    font-size: 16px;
    font-weight: bold;
    color: #201f26;
    line-height: 1.5;
  }
  ${Media.phone`
    width: 94%;
    margin: ${p => (p.isSmb ? '0 0 .5rem 0' : 'auto auto .3rem auto')};
    svg {
      width: .96rem;
      height: .96rem;
      margin-right: .3rem;
      margin-left: .1rem;
    }
    .banner-desc {
      font-size: .36rem;
      b {
        font-size: .78rem;
      }
    }
    p {
      font-size: .24rem;
    }
  `}
  ${p => p.theme.Hack.ja`
    width: 100%;
    ${Media.phone`
      width: 100%;
    `}
  `}
`

export const SmbTag = styled.div`
  padding: 16px 30px;
  border: 2px solid #fd5c1f;
  border-radius: 10px;
  color: #fd5c1f;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .smb-tag-title {
    font-size: 36px;
    font-weight: bold;
    color: #fd5c1f;
    line-height: 30px;
    .smb-tag-unit {
      font-size: 18px;
      font-weight: bold;
    }
  }
  .smb-tag-desc {
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    margin-top: 2px;
  }
  ${NewMedia.phone`
    padding: .16rem .3rem;
    .smb-tag-title {
      font-size: .36rem;
      line-height: 1;
      .smb-tag-unit {
        font-size: .18rem;
        font-weight: bold;
      }
    }
    .smb-tag-desc {
      font-size: .22rem;
      line-height: 1;
    }
  `}
`

export const BannerRightBox = styled.div`
  padding-top: 58px;
  ${NewMedia.phone`
    padding-top: 0;
    margin: ${p => (p.isSmb ? '.73rem auto 0 auto' : '.3rem auto 0 auto')};
    img{
      width:${p => (p.isSmb ? '5.94rem' : '6.52rem')};
    }
  `}
`

export const SmbButton = styled(Button)`
  min-width: 220px;
  line-height: 1;
  height: 44px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  svg {
    width: 20px;
    height: 18px;
    margin-left: 8px;
  }
  ${Media.phone`
    min-width: unset !important;
    height: .8rem;
    svg {
      width: .25rem;
      height: .2rem;
      margin-left: .2rem;
    }
  `}
  ${NewMedia.phone`
    font-size:.3rem;
    width: 4rem;
    height: .7rem;
  `}
  ${p => p.theme.Hack.ja`
    font-size: 16px;
  `}
`

export const BannerBox = styled.div`
  width: 1400px;
  height: 600px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
  ${Media.phone`
    width: 100%;
    height: 11.4rem;
    display: block;
    margin-top: 1.6rem;
  `}
`

export const BannerLeft = styled.div`
  width: 536px;
  height: 396px;
  margin-top: 53px;
  h1 {
    font-family: Roboto;
    font-size: 56px;
    line-height: 66px;
    font-weight: bold;
    color: #fd5c1f;
    span {
      line-height: 0.4;
      font-family: Roboto;
      font-size: 42px;
      font-weight: 800;
      color: #ffffff;
    }
  }

  p {
    font-size: 20px;
    font-weight: normal;
    line-height: 30px;
    color: #c2c3c4;
    margin-top: 40px;
  }
  ${Media.phone`
    width: 100%;
    height: 6rem;
    margin-top: 0;
    padding: 0 0.4rem;
    h1 {
      width: 100%;
      font-size: 0.8rem;
      line-height: 0.8rem;
      span {
        font-size: 0.48rem;
        line-height: 0.4rem;
      }
    }

    p {
      width: 100%;
      font-size: 0.32rem;
      line-height: 0.4rem;
      margin-top: 0.3rem;
    }
  `}
`

export const BannerRight = styled.div`
  width: 790px;
  height: 476px;
  margin: auto;
  margin-right: 0px;
  margin-top: 62px;
  ${Media.phone`
    width: 6.7rem;
    height: 4rem;
    margin: 0 auto;
    margin-top: 0.6rem;
    margin-left: 0.4rem;
    img{
      width: 6.7rem;
      height: 4rem;
    }
  `}
`

export const BannerBt = styled.div`
  display: flex;
  justify-content: left;
  height: 56px;
  position: absolute;
  margin-top: 40px;
  ${Media.phone`
    margin-top: 0.4rem;
  `}
`

export const FreeButton = styled.div`
  width: 220px;
  height: 56px;
  border-radius: 4px;
  background: #fd5c1f;
  font-size: 16px;
  font-weight: normal;
  line-height: 16px;
  text-align: center;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover {
    background: #b24116;
    border: 1px solid #ea561e;
  }
  ${Media.phone`
    width: 3.2rem;
    height: 0.8rem;
    font-size: 0.26rem;
  `}
`

export const PricingButton = styled.div`
  width: 170px;
  height: 56px;
  border-radius: 4px;
  opacity: 1;
  box-sizing: border-box;
  border: 2px solid #fd5c1f;
  color: #fd5c1f;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  margin-left: 30px;
  cursor: pointer;
  &:hover {
    background: #ffefe9;
    border: 2px solid #fd5c1f;
  }
  ${Media.phone`
    width: 2.4rem;
    height: 0.8rem;
    margin: 0 auto;
    margin-left: 0.6rem;
  `}
`

export const BannerBottom = styled.div`
  width: 1400px;
  height: 42px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${Media.phone`
    width: 6.7rem;
    height: 0.36rem;
    margin: 0 auto;
    img{
      height: 0.32rem;
      width: auto;
    }
  `}
`
